/* BoardHouse — mega menu abre no hover */
(function () {
  function initMegaMenuHover() {
    document.querySelectorAll('.mega-menu').forEach(function (menu) {
      var closeTimer;

      menu.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        menu.open = true;
      });

      menu.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          menu.open = false;
        }, 120);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuHover);
  } else {
    initMegaMenuHover();
  }
})();
